import { createFromIconfontCN } from "@ant-design/icons";
export const IconFont = createFromIconfontCN({
	scriptUrl: [
	"//at.alicdn.com/t/c/font_3566948_2xduf2s6ell.js"
	
	],
});
